/**
 * Initializes color input fields with an accompanying read-only text field
 * that displays the selected color's hex value.
 *
 * This function looks for all elements with the `.color-input-with-text` class,
 * and for each one:
 *  - Synchronizes the hex value from the <input type="color"> to the adjacent
 *    read-only text input.
 *  - Updates the text field whenever the color input changes.
 *
 * Intended for use in UI components where both visual color selection
 * and manual hex visibility are needed.
 */

export const initColorInputText = () => {
  const colorPickers = document.querySelectorAll('.color-input-with-text');

  colorPickers.forEach((wrapper) => {
    const colorInput = wrapper.querySelector('.form-control-color');
    const textInput = wrapper.querySelector('.form-control-color-value');

    const updateHex = () => {
      textInput.value = colorInput.value.toUpperCase();
    };

    colorInput.addEventListener('input', updateHex);

    // Initialize on load
    updateHex();
  });
};
